import Gamma from './Gamma.jsx';

export default Gamma;